<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="closeModal" fullscreen>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name
        }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <v-stepper v-model="step">
              <!-- STEPPER HEADERS -->
              <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">Rol</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">Permisos</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items style="background-color: rgb(221, 225, 230)">
                <v-stepper-content step="1">
                  <v-row class="justify-content-center" style="min-height: 65vh; background: white">
                    <v-col md="4" class="align-content-center">
                      <p class="fs-16"><b>Ingrese los datos del rol</b></p>

                      <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name"
                        v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                      <span class="red--text">{{ errors.first("name") }}</span>

                      <v-checkbox label="Habilitado" :disabled="isViewModal()" v-model="item.enable"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <!-- STEP 2: Permisos -->
                <v-stepper-content step="2">
                  <v-container fluid class="mt-0">
                    <v-row>
                      <v-col cols="4" md="4" sm="12">
                        <v-card class="mx-auto" tile>
                          <v-list>
                            <v-subheader style="font-size: 16px">Menu</v-subheader>
                            <v-divider class="mb-0"></v-divider>
                            <v-list-item-group v-model="selectedItem" color="primary" mandatory>
                              <v-list-item v-for="(item, i) in categories" :key="item.id" :value="item.id">
                                <v-list-item-icon>
                                  <font-awesome-icon :icon="item.icon" />
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-card>

                      </v-col>
                      <v-col cols="8" md="8" sm="12">
                        <v-card class="mx-auto" tile>

                          <v-data-table v-if="selectedItem != null" :disabled="isViewModal()" :headers="headers_modules"
                            :items="filteredModules" :loading="loading_modules" :hide-default-footer="true"
                            :disable-pagination="true" loading-text="Cargando... Por favor espere">
                            <template v-slot:item="props">
                              <tr v-if="!props.item.internal">
                                <td>{{ props.item.name }}</td>
                                <td><v-checkbox v-model="props.item.list" :disabled="isViewModal()"></v-checkbox></td>
                                <td><v-checkbox v-model="props.item.create" :disabled="isViewModal()"></v-checkbox></td>
                                <td><v-checkbox v-model="props.item.update" :disabled="isViewModal()"></v-checkbox></td>
                                <td><v-checkbox v-model="props.item.delete" :disabled="isViewModal()"></v-checkbox></td>
                         
                                <td><v-checkbox v-model="props.item.sidebar" :disabled="isViewModal()"></v-checkbox>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="step = step - 1" v-if="step > 1" color="blue" text>
              Atras
            </v-btn>
            <v-btn color="error" text @click="closeModal">Cerrar</v-btn>
            <v-btn :loading="loading && loading_categories" @click="validateStep" v-if="step == 1" text color="success">
              Siguiente
            </v-btn>
            <v-btn :loading="loading" text type="submit" v-if="step > 1 && !isViewModal()" color="success">{{ formBtn
              }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { rolService } from "@/libs/ws/rolService";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  computed: {
    filteredModules() {
      if (this.selectedItem === null) return [];
      return (this.item.modules.length ? this.item.modules : this.modules).filter(
        module => module.category === this.selectedItem
      );
    }
  },
  data() {
    return {
      loading: false,
      loading_modules: false,
      loading_categories: false,
      show: false,
      modules: [],
      step: 1,
      categories: [],
      selectedItem: null,
      headers_modules: [
        { text: "Nombre", value: "name" },
        { text: "Listar", value: "list" },
        { text: "Crear", value: "create" },
        { text: "Editar", value: "update" },
        { text: "Eliminar", value: "delete" },
        { text: "Acceso desde Panel", value: "sidebar" },
      ],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      if (!this.dialog) this.loadModules();
      this.errors.clear();
    },
  },
  mounted() {
    this.loadModules();
    this.loadCategories();
  },
  methods: {
    closeModal() {
      this.$emit("updateDialog", false);
      this.step = 1;
    },
    validateStep() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.step = this.step + 1;
        }
      });
    },
    loadCategories() {
      this.loading_categories = true;
      rolService
        .llstCategoriesModule()
        .then((response) => {
          this.categories = response.result;
          this.loading_categories = false;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
          this.loading_categories = false;
        })
        .finally(() => {

        });
    },
    loadModules() {
      this.loading_modules = true;
      rolService
        .listModules()
        .then((response) => {
          this.modules = response.result;
          this.loading_modules = false;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
          this.loading_modules = false;
        });
    },
    isViewModal() {
      return this.formBtn == "";
    },
    createItem(e) {
      if (this.loading) return;

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;

          e.preventDefault();
          if (!this.item.isExternal) {
            this.item.companyExternal = { name: "", id: 1 };
          }
          if (this.item.id > 0) {
            this.service
              .update(this.item)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El rol se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    if (Object.prototype.hasOwnProperty.call(response, "message")) {
                      this.$toast.error(response.message, "Error");
                    } else {
                      this.$toast.error(response.msg, "Error");
                    }
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          } else {
            this.item.modules = this.modules;
            this.service
              .create(this.item)
              .then((response) => {
                if (response.status) {
                  this.$toast.success("El rol se creo correctamente", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        }
      });
    },
  },
};
</script>
